const Solution = () => {
  const avantages = [
    {
      icon: '📱',
      title: 'Digitalisation complète',
      description: 'Fini les tickets papier ! Tout se fait depuis votre smartphone avec une interface intuitive et moderne.'
    },
    {
      icon: '⚡',
      title: 'Temps réel',
      description: 'Données synchronisées instantanément entre tous les acteurs : utilisateurs, contrôleurs et gestionnaires.'
    },
    {
      icon: '💳',
      title: 'Paiements digitaux',
      description: 'Paiement sécurisé en ligne, portefeuille électronique intégré, plus besoin de monnaie.'
    },
    {
      icon: '🎯',
      title: 'Optimisation intelligente',
      description: 'Analytics avancés pour maximiser les revenus, optimiser les tarifs et améliorer l\'occupation.'
    },
    {
      icon: '🔍',
      title: 'Contrôle automatisé',
      description: 'Scan automatique des plaques, vérification instantanée des tickets, réduction des erreurs.'
    },
    {
      icon: '📊',
      title: 'Données centralisées',
      description: 'Tableau de bord complet avec toutes les statistiques, rapports et analyses en un seul endroit.'
    }
  ];

  return (
    <section id="solution" className="py-24 bg-gradient-to-br from-primary-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Notre solution
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-6">
            <strong>Tunisie Parking</strong> est une plateforme complète qui transforme radicalement 
            la gestion du stationnement grâce à la technologie moderne.
          </p>
          <div className="inline-block px-6 py-3 bg-primary-600 text-white rounded-full font-semibold">
            🚀 Projet nextTunisia - Digitalisation Horizon 2030
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {avantages.map((avantage, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-primary-100"
            >
              <div className="text-4xl mb-4">{avantage.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {avantage.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {avantage.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-primary-600 to-primary-800 rounded-2xl p-8 text-white shadow-xl">
          <div className="text-center">
            <h3 className="text-2xl sm:text-3xl font-bold mb-3">
              Un écosystème complet en 3 applications
            </h3>
            <p className="text-lg text-white/90 mb-6 max-w-2xl mx-auto">
            Notre solution se compose de trois briques essentielles qui travaillent en parfaite 
              synchronisation : une application mobile pour les citoyens, une application contrôleur 
              pour les agents, et un tableau de bord web pour les gestionnaires.
            </p>
            <a
              href="#briques"
              className="inline-flex items-center px-6 py-3 bg-white text-primary-700 font-semibold rounded-lg shadow-lg hover:bg-gray-100 transition-all duration-300"
            >
              Découvrir les 3 briques
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solution;

